import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { Route } from "routes/utils/types";

import { ability } from "./config/ability";
import { authorizedRoutesAtom } from "./state";
import { useAuthorization } from "./useAuthorization";

export const useAuthorizedRoutes = (routes: Route[]): Route[] => {
  const { isAuthCheckDone } = useAuthorization();
  const [routesArray, setRoutesArray] = useRecoilState(authorizedRoutesAtom);

  const routesRef = useRef(routes);
  routesRef.current = routes;

  useEffect(() => {
    if (isAuthCheckDone && routesRef.current) {
      try {
        const cleanedRoutes = traverseRoutes(routesRef.current);
        setRoutesArray(cleanedRoutes);
      } catch (err) {
        console.error(err);
      }
    }
  }, [isAuthCheckDone]);

  return isAuthCheckDone ? routesArray : routes;
};

const traverseRoutes = (routes: Route[], path: string[] = ["Home"]): Route[] => {
  return routes.reduce<Route[]>((filteredRoutes, route) => {
    const subject = route.scope === "Home" ? route.scope : `${path.join("/")}/${route.scope}`;

    if (ability.can("read", subject)) {
      const children = traverseRoutes(route.children ?? [], [subject]);
      return filteredRoutes.concat({ ...route, children });
    }
    return filteredRoutes;
  }, []);
};

export const checkRouteAccess = (route: Route) => {
  const [subject, actionPre = "read"] = (route.scope ?? "Home").split(".") as [string, string];
  const action = actionPre.toLocaleLowerCase();

  if (ability.can("*", "*") || ability.can(action, subject)) return route;
};
